import React, { Dispatch, SetStateAction } from "react";
import styled from "styled-components";

import { Link } from "@global";
import { Container, P } from "@util/standard";
import { assets, isEveryday } from "@util/constants";
import {
  AbsoluteWrapper,
  DropDownWrapper,
  SubLinkContainer,
} from "./shared.styles";
import { Color } from "@util/types";

interface Props {
  data: Queries.SanityMegaMenuLinks;
  hover: boolean | undefined;
  setHover: Dispatch<SetStateAction<number>>;
  hoverIndex: number;
  showArrowIcon?: boolean;
  color?: Color;
  padding?: string;
}

const LinksContainer = styled(Container)`
  flex-flow: column wrap;

  b {
    color: var(--theme-button-color);
    font-weight: 600;
  }

  > * {
    margin: 6px 90px 6px 0;
  }
`;

const MenuDropDown = ({
  data,
  hover,
  setHover,
  hoverIndex,
  showArrowIcon,
  color,
  padding,
}: Props) => {
  const updateHover = (value: number) => {
    setHover(value);
  };
  const clearHover = () => {
    updateHover(-1);
  };

  const Dropdown = () => {
    return (
      <AbsoluteWrapper isHovered={hover} onMouseLeave={clearHover} zIndex={100}>
        <DropDownWrapper>
          {data.links?.map((link, index) => {
            if (!link) return null;

            const perChunk = 8;
            const linkSets =
              link?.links &&
              link.links.reduce(
                (resultArray: any[], item: any, index: number) => {
                  const chunkIndex = Math.floor(index / perChunk);

                  if (!resultArray[chunkIndex]) {
                    resultArray[chunkIndex] = []; // start a new chunk
                  }

                  resultArray[chunkIndex].push(item);

                  return resultArray;
                },
                [],
              );

            return (
              <SubLinkContainer
                key={`${link._key}-${index}`}
                isLast={(data.links && data.links?.length - 1) === index}
              >
                {linkSets?.map((linkSet, colIndex) => {
                  return (
                    <LinksContainer key={colIndex}>
                      {link.title && colIndex === 0 && <b>{link.title}</b>}
                      {linkSet && (
                        <>
                          {linkSet?.map((subLink: any) => {
                            if (subLink == null) {
                              return null;
                            }

                            return (
                              <Link
                                margin="10px 0"
                                key={subLink._key}
                                {...subLink}
                                onClick={clearHover}
                              />
                            );
                          })}
                        </>
                      )}
                    </LinksContainer>
                  );
                })}
              </SubLinkContainer>
            );
          })}
        </DropDownWrapper>
      </AbsoluteWrapper>
    );
  };

  return (
    <Container
      padding={padding}
      alignItems="center"
      onMouseEnter={() => updateHover(hoverIndex)}
    >
      <Link
        internallink
        linktext={data.title}
        url={data.slug?.current}
        color={color}
        onClick={clearHover}
        className={!isEveryday ? "header-link" : undefined}
      />
      {showArrowIcon && (
        <img
          width="8px"
          height="5px"
          src={hover ? assets.arrowUp : assets.arrowDown}
        />
      )}

      {hover && <Dropdown />}
    </Container>
  );
};

export default MenuDropDown;
